import React, {Component} from 'react';
import {connect} from "react-redux";
import Modal from 'react-bootstrap/Modal'
import {formatNumberToPersian} from '../../utils/Utility'

class Selectbox extends Component {

    constructor(props) {
        super(props)
        this.state = {
            show: false,
        }
    }

    render() {
        return (
            <div style={{'display': 'inline'}}>
                <button
                    className={this.props.className + " " + (this.props.value && this.props.activeClassName ? this.props.activeClassName : '')}
                    onClick={() => this.setState({show: true})}>
                    <span>
                    {
                        this.props.value ? (formatNumberToPersian(this.props.value.address ? this.props.value.address : ( this.props.value.title ? this.props.value.title : this.props.value.name)))
                            :
                            (this.props.defaultTitle ? this.props.defaultTitle : 'انتخاب کنید')
                    }
                    </span>
                    {/*<i className="icon-back arrow-choose"/>*/}
                </button>

                <Modal
                    style={{'overflow': 'auto'}}
                    show={this.state.show}
                    onHide={() => this.setState({show: false})}
                    centered={true}
                    size={"sm"}
                >
                    <div className="select-box">
                        {
                            this.props.noneValue ?
                                (<button onClick={() => {
                                    this.setState({show: false})
                                    if (this.props.onSelect)
                                        this.props.onSelect(null)
                                }}>{this.props.noneTitle ? this.props.noneTitle : 'حذف انتخاب'}</button>)
                                :
                                (null)

                        }
                        {
                            this.props.items.map((item, i) => (
                                <button key={i} onClick={() => {
                                    this.setState({show: false})
                                    if (this.props.onSelect)
                                        this.props.onSelect(item)
                                }}>{item.address ? item.address : (item.title ? item.title : item.name)}</button>
                            ))
                        }
                    </div>
                </Modal>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const mapStateToProps = (state) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Selectbox)
